/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Keep hidden navigation imagery out of the critical loading path. Shopify's
 * native lazy-loading heuristic still fetches images that are positioned near
 * the viewport even when their mega menu is closed, so these images are
 * hydrated only when the related menu receives real user intent.
 */
(function () {
  'use strict';

  var deferredImageSelector = 'img[data-deferred-src]';

  function hydrateDeferredImages(root) {
    if (!root) return;

    root.querySelectorAll(deferredImageSelector).forEach(function (image) {
      var deferredSrcset = image.getAttribute('data-deferred-srcset');
      var deferredSrc = image.getAttribute('data-deferred-src');

      if (deferredSrcset) image.srcset = deferredSrcset;
      if (deferredSrc) image.src = deferredSrc;

      image.removeAttribute('data-deferred-srcset');
      image.removeAttribute('data-deferred-src');
    });
  }

  function handleMenuIntent(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var control = target.closest('[aria-controls]');
    if (control) {
      var controlledId = control.getAttribute('aria-controls');
      if (controlledId) hydrateDeferredImages(document.getElementById(controlledId));
    }

    var megaMenuContainer = target.closest('.has-mega-menu, .mega-menu');
    if (megaMenuContainer) hydrateDeferredImages(megaMenuContainer);
  }

  document.addEventListener('pointerover', handleMenuIntent, { passive: true });
  document.addEventListener('focusin', handleMenuIntent);
  document.addEventListener('click', handleMenuIntent, { passive: true });
})();
